import { SkeletonLoaderArea, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Title = styled.p`
  color: var(--text-default);
  margin: 0 0 24px 0;
  ${typographyV2.titleLg};
`;

export const styledLoaderAreas: SkeletonLoaderArea[] = [
  {
    styles: {
      width: '100%',
      height: '100px',
      borderRadius: '8px',
    },
  },
];

export const StyledLoaderWrapper = styled.div`
  margin-top: 24px;
`;

export const Wrapper = styled.div`
  display: flex;
  gap: 32px;
  flex-direction: column;
`;
